import allDemand from "./allDemand.vue";
import mySubmit from "./mySubmit.vue";
import myTake from "./myTake.vue";
import addDemand from "./addDemand.vue";
import infoDemand from "./infoDemand.vue";
import editDemand from "./editDemand.vue";
let a = Object.assign({ allDemand, mySubmit, myTake, addDemand, infoDemand, editDemand })
export default a